import { MultipleQueriesQuery } from '@algolia/client-search'
import algoliasearch, { SearchClient } from 'algoliasearch/lite'

const API_KEY = '4907335f4b6086c4df0c0c24efccf21c'

const client = algoliasearch('828XMGE2HM', API_KEY)

/**
 * This proxy around the search client is to avoid requests to algolia when there is no query in the
 * search.
 *
 * See https://www.algolia.com/doc/guides/building-search-ui/going-further/conditional-requests/react/
 */
export const algoliaClient = {
  search(queries: readonly MultipleQueriesQuery[]) {
    if (queries.every(({ params }) => !params?.query)) {
      return Promise.resolve({
        results: queries.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          processingTimeMS: 0
        }))
      })
    }

    return client.search(queries)
  }
} as SearchClient
